export default {
  zh: {
    email: '邮箱',
    yourCode: '验证码',
    sendEmail: '发送邮件',
    sent: '已发送',
    next: '下一步',
    networkError: '网络错误，请稍后再试',
    resetPassword: '验证码已发送到',
    sendToprompt: '可能需要等待几分钟，请确保检查您的垃圾邮箱。',
    confirm: '确定',
  },
  en: {
    email: 'Email',
    yourCode: 'Your Code',
    sendEmail: 'Send Email',
    sent: 'Sent',
    next: 'Next',
    networkError: 'Network error, please try again later',
    resetPassword: 'Verification code have been sent to',
    sendToprompt: 'You may have to wait a few minutes, please make sure to check your garbage mailbox.',
    confirm: 'confirm',
  }
}



// WEBPACK FOOTER //
// ./src/views/forgotpwd/forgotEmailPwd/lang.js